export function objectShallowEq<T>(prev: Record<string, T>, next: Record<string, T>): boolean {
    return (
        Object.keys(prev).length === Object.keys(next).length &&
        Object.keys(prev).every((key) => prev[key] === next[key])
    );
}
